<template>
  <div>
    <!-- <div v-show="false"> {{getActionListCounter}} </div> -->
    <v-btn flat :color="ui.btnColor" @click="openImport()"
    :disabled="false">
      <v-icon left :color="ui.btnColor">
        {{item.btnIcon}}
      </v-icon>
      {{item.btnTitle}}
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-icon left color="wplblue0"> search </v-icon>
          <span :class="ui.textTitle">
            {{item.title}}
          </span>
        </v-card-title>
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs10>
                  <v-text-field v-model="search.title"
                    :label="item.searchLabel1" :prepend-icon="item.searchIcon1">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap
              v-if="this.data.tag === 'G6'">
                <v-flex xs10>
                  <v-select
                    v-model="search.type"
                    :items="importTypesSearch"
                    label="relationship search"
                    color="wplblue0"
                    prepend-icon="category"
                    hint="relationship type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <div v-if="this.getSearchResults !== null" class="mt-4">
                <v-layout row class="mr-3 ml-3">
                  <v-flex xs12>
                    <v-data-table
                    :headers="headers"
                    :items="getSearchResults"
                    class="elevation-1"
                    :total-items=this.maxRows
                    :hide-actions=this.hideActions
                    >
                     <template slot="items" slot-scope="props">
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item0}}
                       </td>
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item1 }}
                       </td>
                       <td class="text-xs-right">
                          <v-btn :color="ui.btnColor" dark icon small
                          :disabled="disableAppendAdd(props.item.basic.did)"
                          @click="changeItem(props.item, 'add')"
                          >
                            <v-icon> add </v-icon>
                          </v-btn>
                       </td>
                     </template>
                   </v-data-table>
                   <v-layout row>
                     <v-progress-linear class="ml-2 mr-2"
                     :color="ui.btnColorGrey"
                     height="5"
                     :indeterminate="this.progressBarImportRelps"/>
                   </v-layout>
                 </v-flex>
                </v-layout>
              </div>
           </v-container>
           <v-layout  row>
             <v-btn
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              class="hidden-xs-only"
              >
               <v-icon left> exit_to_app </v-icon>
               Close
             </v-btn>
             <v-btn
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              class="hidden-sm-and-up"
              >
               <v-icon> exit_to_app </v-icon>
             </v-btn>
             <v-spacer/>
             <v-btn
               flat
               dark
               :color="ui.btnColor"
               class="hidden-xs-only"
               @click="changeItem(null, 'remove')">
               <v-icon left>remove</v-icon>
               remove
             </v-btn>
             <v-btn
               flat
               dark
               :color="ui.btnColor"
               class="hidden-sm-and-up"
               @click="changeItem(null, 'remove')">
               <v-icon>remove</v-icon>
             </v-btn>
             <div v-if="this.enableSpinBtnSearch === false">
               <v-btn
                 flat
                 dark
                 :color="ui.btnColor"
                 :disabled="!this.enableSearch"
                 class="hidden-xs-only"
                 @click="searchBeforeImport(search)">
                 <v-icon left>search</v-icon>
                 search
               </v-btn>
               <v-btn
                 flat
                 dark
                 :color="ui.btnColor"
                 :disabled="!this.enableSearch"
                 class="hidden-sm-and-up"
                 @click="searchBeforeImport(search)">
                 <v-icon>search</v-icon>
               </v-btn>
             </div>
             <div v-else>
               <BtnSpin :btnSpec="btnInfo1"/>
             </div>
          </v-layout>
         </v-form>
    </v-card>

    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import announcements from "@/frame/messages/mixins/announcements.js";
import importOptions from "@/data/options/mixins/importOptions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import search from "@/data/search/mixins/search.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";

export default {
  // eslint-disable-next-line
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  // eslint-disable-next-line
  mixins: [
    // role,
    search,
    announcements,
    apptheme,
    dataSources,
    docRevsModFunctions,
    listFunctions,
    importOptions,
    numberFunctions,
    relps,
    revFunctions,
    getData,
    createFirebase
    // rolesFormValidation
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      progressBarImportRelps: false,
      enableSpinBtnSearch: false,
      enableSpinBtnAppendGetRelps: false,
      appendLimit: 10,
      maxRows: -1,
      hideActions: true,
      barMovement: false,
      search: {
        router: false,
        type: "Operations Notifications", // type of search
        id: "", // id for search
        title: "", // title for search
        ft: "",
        dbs: "" // data base source
      },
      enableSpinner: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        type: "flat"
      }
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getRelpsRemoteAppended",
      "getDetailBasic",
      "getDetailLink",
      "getSearchResults"
    ]),
    enableSearch() {
      let logic = false;
      if (this.data.tag === "A1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "A1.M") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "B1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "B6") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "B4") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "F1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "E1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "W6") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "E6") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      return logic;
    },
    enableRelpsImport() {
      let logic = false;
      if (this.data.tag === "W6" && this.getDetailBasic.tag === "W1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    item() {
      let obj = {
        btnTitle: "append",
        btnIcon: "download_for_offline",
        title: "",
        searchLabel1: "",
        searchIcon1: "",
        importIcon: ""
      };
      if (this.data.tag === "A1") {
        obj.searchLabel1 = "asset name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "asset";
        obj.btnIcon = "add";
        if (this.getCurrentPage !== "/assetdetail") {
          obj.title = "Asset Search and Append";
        } else {
          obj.title = "Master Asset Append";
        }
      } else if (this.data.tag === "A1.M") {
        obj.title = "Asset Master";
        obj.searchLabel1 = "asset name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "master";
        obj.btnIcon = "home";
      } else if (this.data.tag === "B1") {
        obj.title = "Risk Assessment";
        obj.searchLabel1 = "risk name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "risk";
        obj.btnIcon = "add";
      } else if (this.data.tag === "B6") {
        obj.title = "Business Plan";
        obj.searchLabel1 = "plan name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "plan";
        obj.btnIcon = "add";
      } else if (this.data.tag === "B4") {
        obj.title = "Budget";
        obj.searchLabel1 = "budget name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "budget";
        obj.btnIcon = "add";
      } else if (this.data.tag === "F1") {
        obj.title = "Facility Search and Append";
        obj.searchLabel1 = "facility name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "facility";
        obj.btnIcon = "add";
      } else if (this.data.tag === "E1") {
        obj.title = "Equipment Search and Append";
        obj.searchLabel1 = "equipmemt name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "equipment";
        obj.btnIcon = "add";
      } else if (this.data.tag === "W6") {
        obj.title = "Procedure Search and Append";
        obj.searchLabel1 = "procedure name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "procedure template";
        obj.btnIcon = "add";
      } else if (this.data.tag === "E6") {
        obj.title = "Results Program Search and Append";
        obj.searchLabel1 = "results program name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "results template";
        obj.btnIcon = "add";
      } else {
        obj.title = "Undefined";
      }
      return obj;
    },
    headers() {
      let head = [
        { text: "Undefind", sortable: false },
        { text: "Undefined", sortable: false },
        { text: "", sortable: false }
      ];
      if (this.data.tag === "A1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "A1.M") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "B1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "B6") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "B4") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "E1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "F1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "W6") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "E6") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      return head;
    }
  },
  methods: {
    disableAppendAdd(did) {
      let logic = null;
      if (this.getDetail === null) {
        logic = false;
      } else if (this.getDetail.basic.did === did) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: "",
        item2: ""
      };
      if (this.data.tag === "A1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "A1.M") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "B1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "B6") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "B4") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "E1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "F1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "W6") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "E6") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else {
        obj.item0 = "Undefined";
        obj.item1 = "Undefined";
      }
      return obj;
    },
    openImport() {
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.progressBarImportRelps = false;
      this.$refs.form.reset();
      this.$store.dispatch("changeSearchResults", null);
      // reset search
      this.search.title = "";
      this.search.type = "";
    },
    reset() {
      this.$refs.form.reset();
    },
    closeModal() {
      this.dialog = false;
    },
    searchBeforeImport() {
      this.enableSpinBtnSearch = true;
      let tag = this.data.tag;
      if (tag === "A1.M") {
        tag = "A1"; // special case
      }
      this.search.dbs = this.defineDataSourceFromTag(tag);
      this.searchDocuments(this.search);
    },
    changeItem(item, logic) {
      let link = this.getDetailLink;
      if (this.data.tag === "A1" || this.data.tag === "A1.M") {
        // APPEND ASSET
        if (logic === "add") {
          link.aid = item.basic.id;
          link.aidg = item.basic.idg;
          link.adid = item.basic.did;
          link.at = item.basic.title;
          link.atag = "A1";
          // Add MAP and Grid Info
          if (
            this.getDetailBasic !== null &&
            this.getDetailBasic !== undefined
          ) {
            if (this.getDetailBasic.tag !== "A1") {
              link.asys = item.char.sys;
              link.aunit = item.char.unit;
              link.agrid = item.char.grid;
              link.amap = item.char.map;
            }
          }

          // assign facility to make able to complete work on many facilities
          // eslint-disable-next-line
          if (
            this.getDetailBasic !== null &&
            this.getDetailBasic !== undefined &&
            this.getDetailBasic.tag !== "A1" &&
            this.getUser.pref.select.fdid !== null &&
            this.getUser.pref.select.fdid !== undefined
          ) {
            // char.fid = this.getUser.pref.select.fid ;
            link.fdid = this.getUser.pref.select.fdid;
            link.fidg = this.getUser.pref.select.fidg;
            link.ft = this.getUser.pref.select.fname;
            link.fid = this.getUser.pref.select.fid;
          }
          // Announcements
          let msg = "Asset ";
          msg = msg + link.at;
          msg = msg + " was added.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
        } else {
          // Announcements
          let msg = "Asset ";
          msg = msg + link.at;
          msg = msg + " was removed.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          // RESET
          link.aid = "";
          link.aidg = "";
          link.adid = "";
          link.at = "";
          link.atag = "";
        }
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.$store.dispatch("changeDetailLink", link);
        this.dialog = false;
      }
      if (this.data.tag === "F1") {
        // APPEND ASSET
        if (logic === "add") {
          link.fid = item.basic.id;
          link.fdid = item.basic.did;
          link.ft = item.basic.title;
          link.fidg = item.basic.idg;
        } else {
          link.fid = "";
          link.fdid = "";
          link.ft = "";
          link.fidg = "";
        }
        // RESET ASSET
        if (link.aid !== undefined) {
          link.aid = "";
          link.aidg = "";
          link.adid = "";
          link.at = "";
          link.atag = "";
          link.asys = "";
          link.aunit = "";
          link.agrid = "";
          link.amap = "";
        }
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.dialog = false;
      }
      if (this.data.tag === "W6") {
        if (logic === "add") {
          console.log("");
          console.log(">>> APPENDED WORK PROCEDURE W6 <<<");
          link.wpid = item.basic.id;
          link.wpdid = item.basic.did;
          link.wpt = item.basic.title;
          link.wpidg = item.basic.idg;
          link.wprev = this.displayDocumentRevTypeA(item.rev);

          // IMPORT LIST RESULTS
          this.importRelpsRemoteThenStore("W5", item.basic.did);

          // RESET DETAIL LINK
          // this.resetLinkAppendedProgram();
          if (
            this.getDetailBasic.tag === "W1" ||
            this.getDetailBasic.tag === "M5"
          ) {
            this.progressBarImportRelps = true;
            this.getAppendedRelpsRemoteThenStore(item);
            if (this.getRelpsRemoteAppended !== null) {
              console.log("");
              console.log("APPEND WORK PROCEDURE W6");
              console.log(this.getRelpsRemoteAppended.w5);
              let w5 = this.getRelpsRemoteAppended.w5;
              // UPDATE TASK LIST
              if (w5 !== undefined && w5 !== null) {
                this.$store.dispatch("changeTasksList", w5);
                this.$store.dispatch("changeDetailLink", link);
                // eslint-disable-next-line
                this.$store.dispatch("changeResultsListCounter", w5.length);
              }
            }
          } else {
            this.dialog = false;
          }
        } else {
          console.log("");
          console.log("REMOVE TASK PROCEDURE");
          this.dialog = false;
          link.wpid = "";
          link.wpdid = "";
          link.wpt = "";
          link.wpidg = "";
          link.wprev = "";
          this.$store.dispatch("changeTasksList", []);
          this.$store.dispatch("changeTasksListCounter", 0);
        }
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDetailLink", link);
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.data.tag === "E6") {
        if (logic === "add") {
          console.log("");
          console.log(">>> APPENDED RESULTS E6 <<<");
          link.epid = item.basic.id;
          link.epdid = item.basic.did;
          link.ept = item.basic.title;
          link.epidg = item.basic.idg;
          link.eprev = this.displayDocumentRevTypeA(item.rev);

          // IMPORT LIST RESULTS
          this.importRelpsRemoteThenStore("E5", item.basic.did);

          // RESET DETAIL LINK
          // this.resetLinkAppendedProgram();
          if (
            this.getDetailBasic.tag === "W1" ||
            this.getDetailBasic.tag === "M5"
          ) {
            this.progressBarImportRelps = true;
            this.getAppendedRelpsRemoteThenStore(item);
            if (this.getRelpsRemoteAppended !== null) {
              console.log("");
              console.log("APPEND RELPS for TEST RESULTS");
              console.log(this.getRelpsRemoteAppended.e5);
              let e5 = this.getRelpsRemoteAppended.e5;
              // UPDATE TASK LIST
              if (e5 !== undefined && e5 !== null) {
                this.$store.dispatch("changeResultsList", e5);
                this.$store.dispatch("changeDetailLink", link);
                // eslint-disable-next-line
                this.$store.dispatch("changeResultsListCounter", e5.length);
              }
            }
          } else {
            this.dialog = false;
          }
        } else {
          console.log("");
          console.log(">>> REMOVE RESULTS E6 <<<");
          this.dialog = false;
          link.epid = "";
          link.epdid = "";
          link.ept = "";
          link.epidg = "";
          link.eprev = "";
          this.$store.dispatch("changeResultsList", []);
          this.$store.dispatch("changeResultsListCounter", 0);
        }
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDetailLink", link);
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.data.tag === "E1") {
        if (logic === "add") {
          link.eid = item.basic.id;
          link.edid = item.basic.did;
          link.eidg = item.basic.idg;
          link.et = item.basic.title;
          link.etag = item.basic.tag;
        } else {
          link.eid = "";
          link.eidg = "";
          link.edid = "";
          link.et = "";
          link.etag = "";
        }
        this.$store.dispatch("changeDetailLink", link);
        this.$store.dispatch("changePlanDIDCurrent", link.edid);
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.dialog = false;
      }
      if (this.data.tag === "B1") {
        if (logic === "add") {
          link.rid = item.basic.id;
          link.rdid = item.basic.did;
          link.ridg = item.basic.idg;
          link.rt = item.basic.title;
          link.rtag = item.basic.tag;
        } else {
          link.rid = "";
          link.ridg = "";
          link.rdid = "";
          link.rt = "";
          link.rtag = "";
        }
        this.$store.dispatch("changeDetailLink", link);
        // this.$store.dispatch("changePlanDID", link.rdid);
        // this.$store.dispatch("changePlanDIDCurrent", link.rdid);
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.dialog = false;
      }
      if (this.data.tag === "B6") {
        if (logic === "add") {
          link.pid = item.basic.id;
          link.pdid = item.basic.did;
          link.pidg = item.basic.idg;
          link.pt = item.basic.title;
          link.ptag = item.basic.tag;
          // if current is work then add
          // if (this.getDetail !== null && this.getDetail !== undefined) {
          //   if (
          //     this.getDetail.basic.tag === "W1" ||
          //     this.getDetail.basic.tag === "W2"
          //   ) {
          //     this.createDocumentCopyToMaster(this.getDetail, "B6.W");
          //   }
          // }
        } else {
          link.pid = "";
          link.pidg = "";
          link.pdid = "";
          link.pt = "";
          link.ptag = "";
        }
        this.$store.dispatch("changeDetailLink", link);
        this.$store.dispatch("changePlanDID", link.pdid);
        this.$store.dispatch("changePlanDIDCurrent", link.pdid);
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.dialog = false;
      }
      if (this.data.tag === "B4") {
        if (logic === "add") {
          link.bid = item.basic.id;
          link.bidg = item.basic.idg;
          link.bdid = item.basic.did;
          link.bt = item.basic.title;
          link.btag = item.basic.tag;
        } else {
          link.bid = "";
          link.bdid = "";
          link.bt = "";
          link.bidg = "";
          link.btag = "";
        }
        this.$store.dispatch("changeDetailLink", link);
        this.$store.dispatch("changeBudgetDID", link.bdid);
        this.$store.dispatch("changeBudgetDIDCurrent", link.bdid);
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.dialog = false;
      }
    }
  }
};
</script>
